<script>
import { formatPrice } from '../../../../../../Greativ/helper/price'
import {currency, extraProducts, init, settings} from '@/stores/basket'
import { products, productsTotalVatPrice, productsTotalPrice } from '@/stores/product'
import {
  checkTransport,
  setSelectedCarrierId,
  saveTransport,
  transportTotalVatPrice,
  selectedCarrierId,
  countryCarrierOptions } from '@/stores/transport'
import { clientData } from '@/stores/clientData'
import { setGiftFieldErrorKey } from '@/stores/gift'
import { setStep } from '@/stores/view'

import Alert from '@/components/Alert'
import Transport from '@/components/Transport'
import ProductList from '@/components/Product/List'
import ProductItem from '@/components/Product/Item'
import Button from '@/components/Button'
import Gift from '@/components/Gift'
import { ref } from 'vue'
import { banksInit } from '@/stores/banks'

import BonusCode from '@/components/BonusCode'
import ExtraProductItem from '@/components/ExtraProduct/ExtraProductItem.vue'
import ExtraProductList from '@/components/ExtraProduct/ExtraProductList.vue'
import { csrfToken } from '../../../../../../Greativ/global/csrf'
import axios from 'axios'

export default {
  components: {
    ProductList,
    ProductItem,
    Transport,
    Button,
    Gift,
    Alert,
    BonusCode,
    ExtraProductList,
    ExtraProductItem,
  },
  setup() {
    const loading = ref(false)
    const stepErrorMessage = ref(false)

    const goNextView = async () => {
      await banksInit(null, (productsTotalVatPrice.value + transportTotalVatPrice.value))
      setStep(2)
    }
    const kwotaSelectionHasBeenMade = ref(false)
    const showKwotaPopup = ref(false)
    const triggerKwotaPopup = async () => {
      showKwotaPopup.value = true
    }
    const kwotaDontAddToBasketLoading = ref(false)
    const kwotaDontAddToBasket = async () => {
      kwotaDontAddToBasketLoading.value = true
      kwotaSelectionHasBeenMade.value = true
      await goNextView()
      kwotaDontAddToBasketLoading.value = false
      showKwotaPopup.value = false
    }
    const kwotaAddToBasketLoading = ref(false)
    const kwotaAddToBasket = async () => {
      kwotaAddToBasketLoading.value = true
      const productKwotaByProductId = {}
      const autoAddingProducts = window.shop_basket.kwota.autoAddingProducts
      autoAddingProducts.forEach((autoAddingProduct) => {
        productKwotaByProductId[autoAddingProduct.belongsToProductId] =
          autoAddingProduct
      })
      const addPromises = []
      products.value.forEach((product) => {
        const kwotaProduct = productKwotaByProductId[product.productID] || null
        if (kwotaProduct) {
          addPromises.push(
            new Promise(async (resolve) => {
              try {
                await axios.post(
                  'get/api/template/basket/addItem',
                  {
                    productId: kwotaProduct.id,
                    amount: kwotaProduct.amount * product.amount,
                  },
                  {
                    headers: {
                      'X-CSRF-TOKEN': csrfToken,
                    },
                  }
                )
              } catch (err) {
              } finally {
                resolve(1)
              }
            })
          )
        }
      })
      await Promise.all(addPromises)
      await init()
      kwotaSelectionHasBeenMade.value = true
      showKwotaPopup.value = false
      kwotaAddToBasketLoading.value = false
      window.postMessage({
        method: 'scrollShopBasketView',
        step: 1
      })
    }
    const goNext = async () => {
      loading.value = true
      stepErrorMessage.value = false
      let anyErrors = false
      if (clientData.value && clientData.value.is_gift) {
        if (!clientData.value.gift_giver_name) {
          setGiftFieldErrorKey('gift_giver_name', false)
          anyErrors = true
        }
        if (!clientData.value.gift_recipient_name) {
          setGiftFieldErrorKey('gift_recipient_name', false)
          anyErrors = true
        }
        if (!clientData.value.gift_recipient_text) {
          setGiftFieldErrorKey('gift_recipient_text', false)
          anyErrors = true
        }
      }

      const transportOk = checkTransport()
      if (!transportOk) {
        anyErrors = true
      }
      await saveTransport()
      if (anyErrors) {
        stepErrorMessage.value = true
        loading.value = false
        return
      }
      let askKwota = false
      if (!kwotaSelectionHasBeenMade.value) {
        const kwotaProducts = window.shop_basket.kwota.autoAddingProducts
        if (kwotaProducts.length) {
          const basketProductIds = []
          products.value.forEach((product) => {
            basketProductIds.push(product.productID)
          })
          let basketHasKwotaProduct = false
          let canAddAnyKwotaProduct = false
          kwotaProducts.forEach((kwotaProduct) => {
            if (basketProductIds.includes(kwotaProduct.id)) {
              basketHasKwotaProduct = true
            }
            if (basketProductIds.includes(kwotaProduct.belongsToProductId)) {
              canAddAnyKwotaProduct = true
            }
          })
          if (!basketHasKwotaProduct) {
            askKwota = canAddAnyKwotaProduct
          }
        }
      }
      if (askKwota) {
        await triggerKwotaPopup()
      } else {
        await goNextView()
      }
      loading.value = false
    }

    return {
      formatPrice,
      settings,
      currency,
      products,
      productsTotalVatPrice,
      transportTotalVatPrice,
      loading,
      stepErrorMessage,
      extraProducts,
      goNext,
      kwotaDontAddToBasket,
      kwotaDontAddToBasketLoading,
      kwotaAddToBasket,
      kwotaAddToBasketLoading,
      showKwotaPopup,
    }
  },
}
</script>

<template>
  <teleport to="body">
    <Transition
      name="tw-custom-fade"
      mode="out-in"
      enterActiveClass="transition-opacity duration-300"
      enterFromClass="opacity-0"
      leaveActiveClass="transition-opacity duration-300"
      leaveToClass="opacity-0"
    >
      <div
        class="z-100 fixed inset-0 bg-black bg-opacity-70"
        v-if="showKwotaPopup"
      ></div>
    </Transition>
    <Transition
      name="tw-custom-fade"
      mode="out-in"
      enterActiveClass="transition-opacity duration-300"
      enterFromClass="opacity-0"
      leaveActiveClass="transition-opacity duration-300"
      leaveToClass="opacity-0"
    >
      <div class="fixed inset-0 overflow-y-auto z-101" v-if="showKwotaPopup">
        <div class="flex min-h-full items-center justify-center p-[1.6rem]">
          <div class="bg-white p-12">
            <h3 class="mb-8 !text-[2.5rem]">{{ __('kwota.title') }}</h3>
            <div class="flex flex-wrap justify-end gap-[1.6rem] mt-10">
              <div class="w-full sm:!w-auto">
                <Button
                  class="w-full sm:!w-auto"
                  styleType="secondary"
                  :disabled="kwotaAddToBasketLoading"
                  :loading="kwotaDontAddToBasketLoading"
                  @click="kwotaDontAddToBasket"
                  >{{ __('kwota.btnDontAddToBasket') }}
                </Button>
              </div>
              <div class="w-full sm:!w-auto">
                <Button
                  class="w-full sm:!w-auto"
                  styleType="green-500"
                  :disabled="kwotaDontAddToBasketLoading"
                  :loading="kwotaAddToBasketLoading"
                  @click="kwotaAddToBasket"
                  >{{ __('kwota.btnAddToBasket') }}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </teleport>
  <ProductList>
    <ProductItem
      v-for="product in products"
      :key="product.uID"
      :product="product"
      :locked="loading"
    />
  </ProductList>
  <div class="mt-20 space-y-10">
    <Gift :locked="loading" v-if="false" />

    <div
      class="border-0 border-b-2px border-solid border-gray-700 pb-10"
      v-if="extraProducts.length"
    >
      <h3 class="!text-[2.5rem]">{{ __('extra_product.name') }}</h3>
      <article class="mb-10" v-html="__('extra_product.description')" />

      <ExtraProductList>
        <ExtraProductItem
          v-for="extraProduct in extraProducts"
          :key="extraProduct.id"
          :product="extraProduct"
          :locked="loading"
        />
      </ExtraProductList>
    </div>

    <div class="-m-4 flex flex-wrap justify-end">
      <div class="w-full p-4 lg:w-1/2">
        <BonusCode :locked="loading" />
      </div>

      <div class="w-full p-4 lg:w-1/2">
        <Transport :locked="loading" />
      </div>
    </div>
  </div>
  <template v-if="settings && settings.has_credit && settings.partner_data">
    <div class="mt-20 text-right text-8 font-bold text-red">
      {{
        __('used_credit_title', {
          price: `${formatPrice(
            settings.partner_data.used_credit_in_basket
          )} ${currency}`,
        })
      }}
    </div>

    <div
      class="mb-3 text-right text-8 font-bold text-red"
      v-if="productsTotalVatPrice + transportTotalVatPrice > 0"
    >
      {{
        __('surcharge_title', {
          price: `${formatPrice(
            productsTotalVatPrice + transportTotalVatPrice
          )} ${currency}`,
        })
      }}
    </div>

    <div class="text-right text-8 font-black text-red">
      {{
        __('total_price_title', {
          price: `${formatPrice(
            settings.partner_data.used_credit_in_basket +
              productsTotalVatPrice +
              transportTotalVatPrice
          )} ${currency}`,
        })
      }}
    </div>
  </template>
  <div class="mt-20 text-right text-8 font-black uppercase text-red" v-else>
    {{
      __('total_price_title', {
        price: `${formatPrice(
          productsTotalVatPrice + transportTotalVatPrice
        )} ${currency}`,
      })
    }}
  </div>

  <Alert v-if="stepErrorMessage" class="mt-12 -mb-4">
    {{ __('check_inserted_data') }}
  </Alert>

  <div class="mt-12 text-right">
    <Button :loading="loading" @click="goNext">
      {{ __('btn_next') }}
    </Button>
  </div>
</template>
